import { productosDB } from './index'
import { registrarEntrada } from './movimientos'

export async function obtenerProductos() {
  const result = await productosDB.allDocs({ include_docs: true, descending: false })
  return result.rows.map(r => r.doc).filter(doc => !doc._id.startsWith('_design'))
}

export async function buscarProductos(termino) {
  const todos = await obtenerProductos()
  if (!termino) return todos
  const t = termino.toLowerCase()
  return todos.filter(p =>
    p.nombre.toLowerCase().includes(t) ||
    (p.categoria && p.categoria.toLowerCase().includes(t))
  )
}

export async function buscarPorCodigo(codigo) {
  const todos = await obtenerProductos()
  return todos.find(p => p.codigoBarras && p.codigoBarras === codigo.trim()) ?? null
}

export async function guardarProducto(producto) {
  if (producto._id) {
    const anterior = await productosDB.get(producto._id).catch(() => null)
    const resultado = await productosDB.put(producto)
    // Registrar entrada si el stock aumentó manualmente
    if (
      anterior &&
      typeof anterior.stock === 'number' &&
      typeof producto.stock === 'number' &&
      producto.stock > anterior.stock
    ) {
      await registrarEntrada(producto._id, producto.nombre, anterior.stock, producto.stock)
    }
    return resultado
  }
  const id = `producto_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`
  const nuevo = { _id: id, ...producto, creadoEn: new Date().toISOString() }
  const resultado = await productosDB.put(nuevo)
  // Registrar stock inicial como entrada
  if (typeof producto.stock === 'number' && producto.stock > 0) {
    await registrarEntrada(id, producto.nombre, 0, producto.stock)
  }
  return resultado
}

export async function eliminarProducto(producto) {
  return await productosDB.remove(producto)
}

export async function obtenerProducto(id) {
  return await productosDB.get(id)
}

export async function productosStockBajo(limite = 5) {
  const todos = await obtenerProductos()
  return todos.filter(p => typeof p.stock === 'number' && p.stock <= limite)
}

// Datos de muestra para demo inicial
let _demoPromise = null
export function cargarDatosDemoSiVacio() {
  if (!_demoPromise) _demoPromise = _cargarDemo()
  return _demoPromise
}

async function _cargarDemo() {
  const todos = await obtenerProductos()
  if (todos.length > 0) return

  const demo = [
    { nombre: 'Coca-Cola 600ml', precio: 20, stock: 24, categoria: 'Bebidas', emoji: '🥤', codigoBarras: '7501055300105' },
    { nombre: 'Sabritas Original', precio: 18, stock: 30, categoria: 'Botanas', emoji: '🥔', codigoBarras: '7501011103070' },
    { nombre: 'Pan Bimbo Grande', precio: 55, stock: 8, categoria: 'Panadería', emoji: '🍞', codigoBarras: '7441006501017' },
    { nombre: 'Leche Lala 1L', precio: 28, stock: 12, categoria: 'Lácteos', emoji: '🥛', codigoBarras: '7501055910022' },
    { nombre: 'Huevos docena', precio: 45, stock: 3, categoria: 'Frescos', emoji: '🥚' },
    { nombre: 'Jabón Palmolive', precio: 22, stock: 15, categoria: 'Limpieza', emoji: '🧼', codigoBarras: '7509546066682' },
    { nombre: 'Agua Ciel 1L', precio: 15, stock: 36, categoria: 'Bebidas', emoji: '💧', codigoBarras: '7501055912040' },
    { nombre: 'Frijoles Isadora', precio: 30, stock: 20, categoria: 'Enlatados', emoji: '🫘', codigoBarras: '7501000511058' },
  ]

  for (const p of demo) {
    await guardarProducto(p)
  }
}

